import React from 'react'
import styled from 'styled-components'
import { useField } from 'formik'

import Label from 'atoms/Label'
import { StyledSlider, Thumb, Track } from 'atoms/StyledSlider'
import { parseElectricityBandUsage } from 'helpers/calculations'

const StyledLabelsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  grid-column-gap: 32px;
  @media(max-width: 768px){
    grid-template-columns: 1fr;
    grid-row-gap: 15px;
  }
`

type ValueType = number[]
type RangeArrayFieldProps = {
  className?: string,
  name: string,
  disabled?: boolean,
  labels: Array<string>,
}

const RangeArrayField = ({ className, disabled, name, labels }: RangeArrayFieldProps) => {
  const [, meta, helpers] = useField(name)

  const { value }: { value: ValueType } = meta
  const { setValue } = helpers
  const parsedValue = parseElectricityBandUsage(value)

  return (
    <div className={className}>
      <StyledLabelsContainer>
        {labels.map((label, index) => (
          <Label key={label} color="#333333" weight={400}>
            {label}: {parsedValue[index]}
          </Label>
        ))}
      </StyledLabelsContainer>
      <StyledSlider
        disabled={disabled}
        className="mt-3"
        orientation="horizontal"
        value={value}
        onChange={(event: number | readonly number[]) => { setValue(event) }}
        renderTrack={Track}
        renderThumb={Thumb}
        ariaLabelledby={"Slider"}
        ariaLabel={'slider'}
      />
    </div>
  )
}

export default RangeArrayField
